import {NgModule, ModuleWithProviders} from '@angular/core';
import {LocalStorageService} from './service/local-storage.service';
import {UserPreferencesService} from './service/user-preferences.service';
import {BaseComponent} from './components/base.component';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MDBBootstrapModulesPro} from 'ng-uikit-pro-standard';
import {LocalizationService} from './service/localization.service';
import {AuthorizationService} from './service/authorization.service';
import {DocumentsService} from './service/documents.service';
import {DeleteConfirmationModalComponent} from './components/delete-confirmation-modal/delete-confirmation-modal.component';
import {TitleComponent} from './components/title/title.component';
import {PhotoSelectorComponent} from './components/photo-selector/photo-selector.component';
import {ErrorAlertComponent} from './components/error-alert/error-alert.component';
import {TitleDirective} from './directives/title.directive';
import {BgDirective} from './directives/bg.directive';
import {TextColorDirective} from './directives/text-color.directive';
import {CardSpinnerComponent} from './components/card-spinner/card-spinner.component';
import {WarningAlertComponent} from './components/warning-alert/warning-alert.component';
import {MessageListItemComponent} from './components/message-list-item/message-list-item.component';
import {NotificationListItemComponent} from './components/notification-list-item/notification-list-item.component';
import {NotificationsService} from './service/notifications.service';
import {ImgThumbnailComponent} from './components/img-thumbnail/img-thumbnail.component';
import {InfoAlertComponent} from './components/info-alert/info-alert.component';
import {ChappsCardComponent} from './components/chapps-card/chapps-card.component';
import {ResidentListItemComponent} from './components/resident-list-item/resident-list-item.component';
import {ResidentsService} from './service/residents.service';
import {ErrorLogService} from './service/error-log.service';
import {PhotoViewerService} from './components/photo-viewer/photo-viewer.service';
import {PhotoViewerComponent} from './components/photo-viewer/photo-viewer.component';
import {CreateNotificationModalComponent} from './components/create-notification-modal/create-notification-modal.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {InfoModalComponent} from './components/info-modal/info-modal.component';
import {ChappsAccountService} from './service/chapps-account.service';
import {ChappsCommonAngularLibraryModule, ChappsListModule} from '@npm.chapps.com/chapps.common.angular.library';
import {AnnouncementListItemComponent} from './components/announcement-list-item/announcement-list-item.component';
import {AnnouncementsService} from './service/announcements.service';
import {CreateAnnouncementModalComponent} from './components/create-announcement-modal/create-announcement-modal.component';
import {DatePickerConfigService} from './service/date-picker-config.service';
import {DateService} from './service/date.service';
import {AddressFormatService} from './service/address-format.service';
import {ErrorModalComponent} from './components/error-modal/error-modal.component';
import {HttpHeadersService} from './service/http-headers.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthInterceptor} from '../../http/auth.interceptor';
import { ApplicationStyleService } from './service/application-style.service';
import { SpfRecordService} from "./service/spf-record.service";
import {FeatureGuard} from "./service/FeatureGuard";
import {FeatureService} from "./service/feature.service";
import {EmailSettingsService} from "./service/EmailSettingsService";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        NgSelectModule,
        MDBBootstrapModulesPro,
        ChappsListModule,
        ChappsCommonAngularLibraryModule,
        ReactiveFormsModule,
    ],
  declarations: [
    BaseComponent,
    DeleteConfirmationModalComponent,
    TitleComponent,
    PhotoSelectorComponent,
    ErrorAlertComponent,
    WarningAlertComponent,
    InfoAlertComponent,
    TitleDirective,
    BgDirective,
    TextColorDirective,
    CardSpinnerComponent,
    MessageListItemComponent,
    NotificationListItemComponent,
    ImgThumbnailComponent,
    ChappsCardComponent,
    ResidentListItemComponent,
    InfoModalComponent,
    PhotoViewerComponent,
    CreateNotificationModalComponent,
    AnnouncementListItemComponent,
    CreateAnnouncementModalComponent,
    ErrorModalComponent,
  ],
  exports: [
    BaseComponent,
    DeleteConfirmationModalComponent,
    TitleComponent,
    PhotoSelectorComponent,
    ErrorAlertComponent,
    WarningAlertComponent,
    InfoAlertComponent,
    TitleDirective,
    BgDirective,
    TextColorDirective,
    CardSpinnerComponent,
    MessageListItemComponent,
    NotificationListItemComponent,
    ImgThumbnailComponent,
    ChappsCardComponent,
    ResidentListItemComponent,
    InfoModalComponent,
    PhotoViewerComponent,
    CreateNotificationModalComponent,
    AnnouncementListItemComponent,
    CreateAnnouncementModalComponent,
    ErrorModalComponent,
  ],
  entryComponents: [
    NotificationListItemComponent,
    CreateNotificationModalComponent,
    ResidentListItemComponent,
    AnnouncementListItemComponent,
    CreateAnnouncementModalComponent
  ]
})
export class SharedModule {

  static forChild(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      ],
    };
  }

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        LocalizationService,
        AuthorizationService,
        LocalStorageService,
        UserPreferencesService,
        DocumentsService,
        NotificationsService,
        ResidentsService,
        AnnouncementsService,
        ApplicationStyleService,
        ErrorLogService,
        PhotoViewerService,
        ChappsAccountService,
        DatePickerConfigService,
        DateService,
        AddressFormatService,
        HttpHeadersService,
        SpfRecordService,
        FeatureService,
        FeatureGuard,
        EmailSettingsService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
       ],
    };
  }
}
